// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__RgOgC","title":"FrontImage_title__1OWcH"};